import gsap from "gsap";
import {math} from "./Utils";
import Swiper, {Autoplay, Mousewheel, Navigation, Pagination, Scrollbar,} from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Mousewheel]);

class SliderStories {
	static instance = null;

	static create(options) {
		if (SliderStories.instance === null) {
			SliderStories.instance = new SliderStories(options);
		}
	}

	get defaultOptions() {
		return {
			selector: null,
			next: null,
			prev: null,
			pagination: null,
			container: document,
			speed: 700,
			slidesPerView: 1.001,
		}
	}

	static destroy() {
		if (SliderStories.instance) {
			SliderStories.instance.beforeDestroy();
			SliderStories.instance = null;
		}
	}

	constructor(options) {
		this.options = Object.assign({}, this.defaultOptions, options);
		this.el = this.options.selector;
		this.speed = parseFloat(this.options.selector.getAttribute('data-speed-slide'));
		this.totalSlides = this.options.selector.querySelectorAll('.swiper-slide').length;
		this.init();
	}

	init() {
		this.spotlightSotriesSwiper = new Swiper(
			this.el,
			{
				slidesPerView: this.options.slidesPerView,
				loop: true,
				speed: this.options.speed,
				setWrapperSize: true,
				roundLengths: true,
				grabCursor: true,
				watchSlidesProgress: true,
				mousewheel: false,
				observeParents: true,
				observer: true,
				observeSlideChildren: true,
				resizeObserver: true,
				loopedSlides: 3,
				pagination: {
					el: this.options.pagination,
					type: 'custom',
					renderCustom: (swiper, current, total) => {
						const totalSlides = this.totalSlides;
						const perView = this.options.slidesPerView;
						const totalPages = Math.ceil(totalSlides / perView);
						const currentSlide = current <= totalPages ? current : (current % totalPages || totalPages);
						return ('0' + currentSlide).slice(-2) + '/' + (`0${totalPages}`).slice(-2);
					},
				},
				navigation: {
					nextEl: this.options.next,
					prevEl: this.options.prev,
				},

				on: {
					beforeInit: function (swiper) {
						if (swiper.el.querySelectorAll('.swiper-slide').length == 0) return;
						for (let index = 0; index < 1; index++) {
							swiper.el.querySelectorAll('.swiper-slide').forEach(function (element) {
								let clone = element.cloneNode(true);
								swiper.el.querySelectorAll('.swiper-wrapper')[0].appendChild(clone);
							});
						}

					},
					init: () => {
					},
					slideChange: () => {
					},

					progress: (e, globalProgress) => {
						for (let i = 0; i < e.slides.length; i += 1) {
							const slide = e.slides[i].firstElementChild;
							let progress = e.slides[i].progress;
							let progressAbs = Math.abs(progress);
							let blur = 0;
							let opacity = 1;

							if (progress > -0.1 && progress < 0.1) {
								blur = 0;
								opacity = 1;
							} else {
								if (progress <= -1) {
									blur = 10;
									opacity = 1;
								} else if (progress > 0.99) {
									blur = 10;
									opacity = 0;
								} else if (progress < -0.1 && progress > -1) {
									blur = math.lerp(0, 10, progressAbs);
									opacity = 1;
								} else if (progress > 0.1 && progress < 1) {
									blur = math.lerp(10, 0, progressAbs);
								} else if (progress > 0.8 && progress < 1) {
									opacity = math.lerp(1, 0, progressAbs);
								}
							}

							if (blur > 0) {
								gsap.set(slide, {filter: `blur(${blur}px)`});
							} else {
								gsap.set(slide, {filter: `none`});
							}
							gsap.set(slide, {alpha: opacity});
						}
					},
					setTransition: (e, t) => {
						for (let r = 0; r < e.slides.length; r += 1) {
							const o = e.slides[r].firstElementChild;
							o.style.transitionDuration = `${t}ms`;
						}
					}
				}
			}
		);
	}

	get breakpoints() {
		const breakpoints = {
			'(min-width: 1024px) and (max-width: 1279.98px)': 'desktop',
			'(min-width: 768px) and (max-width: 1023.98px)': 'tablet',
			'(max-width: 767.98px)': 'phone',
			'(min-width: 1280px) and (max-width: 1920px)': 'widescreen',
			'(min-width: 1921px)': 'uhd',
		}

		for (let media in breakpoints) {
			if (window.matchMedia(media).matches) {
				return breakpoints[media];
			}
		}

		return null;
	}

	beforeDestroy() {
		this.spotlightSotriesSwiper.destroy();
		this.el = null;
	}
}


export {SliderStories as default}